import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useGoogleAnalytics } from '../../hooks/google/use-google-analytics';
import CookiesBanner from './cookies-banner';
import CookiePreferencesCenter from './cookies-preferences-center';
var LOCAL_STORAGE_ESSENTIALS_COOKIES_KEY = 'cta_essentials_cookies';
export var LOCAL_STORAGE_ANALYTICS_COOKIES_KEY = 'cta_analytics_cookies';
function Cookies() {
    var init = useGoogleAnalytics().init;
    var dateNow = Date.now().toString();
    var _a = useState(false), showBanner = _a[0], setShowBanner = _a[1];
    var _b = useState(false), showCookiesParams = _b[0], setShowCookiesParams = _b[1];
    useEffect(function () {
        // Show banner if consent hasn't been set
        var essentialConsent = localStorage.getItem(LOCAL_STORAGE_ESSENTIALS_COOKIES_KEY);
        var analyticsConsent = localStorage.getItem(LOCAL_STORAGE_ANALYTICS_COOKIES_KEY);
        if (!essentialConsent || !analyticsConsent) {
            setShowBanner(true);
        }
        if (essentialConsent || analyticsConsent) {
            var diff = 0;
            if (essentialConsent) {
                diff = Math.abs(Number(essentialConsent) - Number(dateNow));
            }
            else if (analyticsConsent) {
                diff = Math.abs(Number(analyticsConsent) - Number(dateNow));
            }
            setShowBanner(diff > 31556952000); // 1 year in ms
        }
    }, [dateNow]);
    var handleAcceptEssential = function () {
        localStorage.setItem(LOCAL_STORAGE_ESSENTIALS_COOKIES_KEY, dateNow);
        setShowBanner(false);
    };
    var handleAcceptAll = function () {
        localStorage.setItem(LOCAL_STORAGE_ESSENTIALS_COOKIES_KEY, dateNow);
        localStorage.setItem(LOCAL_STORAGE_ANALYTICS_COOKIES_KEY, dateNow);
        setShowBanner(false);
        setShowCookiesParams(false);
        init();
    };
    return (_jsxs(_Fragment, { children: [showBanner && !showCookiesParams && (_jsx(CookiesBanner, { handleAcceptAll: handleAcceptAll, handleAcceptEssential: handleAcceptEssential, setShowCookiesParams: setShowCookiesParams, showBanner: showBanner })), showBanner && showCookiesParams && (_jsx(CookiePreferencesCenter, { handleAcceptAll: handleAcceptAll, handleAcceptEssential: handleAcceptEssential, setShowCookiesParams: setShowCookiesParams }))] }));
}
export default Cookies;
